import { render, staticRenderFns } from "./relatedAttributeManageModal.vue?vue&type=template&id=b60c75fa"
import script from "./relatedAttributeManageModal.vue?vue&type=script&lang=js"
export * from "./relatedAttributeManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports